import { useState, useCallback } from 'react'
import ConfirmModal from '../components/ConfirmModal'

interface ConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
  variant?: 'danger' | 'warning' | 'info'
}

export function useConfirm() {
  const [state, setState] = useState<{
    options: ConfirmOptions
    resolve: (value: boolean) => void
  } | null>(null)

  const confirm = useCallback((options: ConfirmOptions): Promise<boolean> => {
    return new Promise((resolve) => {
      setState({ options, resolve })
    })
  }, [])

  const ConfirmDialog = useCallback(() => {
    if (!state) return null

    return (
      <ConfirmModal
        open={true}
        title={state.options.title}
        message={state.options.message}
        confirmText={state.options.confirmText}
        cancelText={state.options.cancelText}
        variant={state.options.variant}
        onConfirm={() => { state.resolve(true); setState(null) }}
        onCancel={() => { state.resolve(false); setState(null) }}
      />
    )
  }, [state])

  return { confirm, ConfirmDialog }
}
